import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { ICMS3TaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class ICMS3Repository extends RepositoryBase<ICMS3TaxTable> {
  protected readonly KEY_PATH = 'icms3';
}
